import React from "react";
import Alert from "./Alert";

// eslint-disable-next-line
export default ({ in: showAlertSuccess }) =>
  showAlertSuccess ? (
    <Alert success>Your changes have been saved successfully</Alert>
  ) : null;
